import { useBranding } from '../branding/BrandingProvider';

export type FlowStep = 'upload' | 'review' | 'processing' | 'dashboard';

interface AppHeaderProps {
  current: FlowStep;
  username?: string;
  onLogout?: () => void;
}

const STEPS: { key: FlowStep; label: string }[] = [
  { key: 'upload', label: '1. Enviar planilha' },
  { key: 'review', label: '2. Conferir dados' },
  { key: 'processing', label: '3. Processar' },
  { key: 'dashboard', label: '4. Gráficos e PDF' },
];

export function AppHeader({ current, username, onLogout }: AppHeaderProps): JSX.Element {
  const branding = useBranding();
  const currentIndex = STEPS.findIndex((step) => step.key === current);

  return (
    <header className="sticky top-0 z-30 border-b border-brand-line bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-4 px-6 py-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-4">
          <img src={branding.logoUrl} alt={branding.appName} className="h-9 w-auto" />
          <div className="hidden h-9 w-px bg-brand-line sm:block" />
          <div className="hidden sm:block">
            <p className="eyebrow">Relatórios de Stakeholders</p>
            <p className="text-sm font-semibold text-brand-graphite">{branding.productName}</p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-4">
          <ol className="flex flex-wrap items-center gap-2 text-xs font-medium">
            {STEPS.map((step, index) => {
              const done = index < currentIndex;
              const active = index === currentIndex;
              return (
                <li
                  key={step.key}
                  className={[
                    'rounded-full border px-3 py-1.5 transition',
                    active
                      ? 'border-brand-red bg-brand-red text-white'
                      : done
                        ? 'border-state-positive/30 bg-state-positive/10 text-state-positive'
                        : 'border-brand-line bg-white text-brand-slate',
                  ].join(' ')}
                  aria-current={active ? 'step' : undefined}
                >
                  {step.label}
                </li>
              );
            })}
          </ol>

          {username && onLogout && (
            <div className="flex items-center gap-2">
              <span className="rounded-full border border-brand-line bg-white px-3 py-1 text-xs font-semibold text-brand-graphite">
                {username}
              </span>
              <button type="button" className="btn-ghost px-3 py-1 text-xs" onClick={onLogout}>
                Sair
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
